import { render } from "./ParagraphMoreLess.component.html?vue&type=template&id=0a571923&scoped=true&ts=true&external"
import script from "./ParagraphMoreLess.component.ts?vue&type=script&lang=ts&external"
export * from "./ParagraphMoreLess.component.ts?vue&type=script&lang=ts&external"

import "./ParagraphMoreLess.component.scss?vue&type=style&index=0&id=0a571923&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a571923"]])

export default __exports__